import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  ListRegistryAssetsParams,
  RegistryAssetList,
  registryApi,
} from '@/shared/api/transcriptor/registryApi';

export type FetchRegistryAssetsMode = 'replace' | 'append';

export type FetchRegistryAssetsArg = Omit<
  ListRegistryAssetsParams,
  'signal'
> & {
  mode?: FetchRegistryAssetsMode;
};

export const fetchRegistryAssets = createAsyncThunk<
  RegistryAssetList,
  FetchRegistryAssetsArg
>('registryAssets/fetch', async (params, { signal }) =>
  registryApi.listRegistryAssets({ ...params, signal }),
);
